// GSAP Animations

( function($) {

  window.onload = function(e){  // on load for GSAP

  gsap.registerPlugin(ScrollTrigger);

  //console.log("animations.js ready");

    
    // RESPONSIVE FUNCTIONS:
    ScrollTrigger.matchMedia({

      
      // lg destkop:
    "(min-width: 1024px)": function() {
      // setup animations and ScrollTriggers for screens 1024px wide or greater here...
      // The ScrollTriggers created inside these functions are segregated and get reverted/killed when the media query doesn't match anymore. 

      
        // =======================================================
        // ***** PDP: HAND ANIMATIONS - DESKTOP ******
        // =======================================================
         if( $('.template-product').length ){   
          gsap.utils.toArray(".js_hand-animation").forEach((container) => {
              let img = container.querySelector("img");
              let tl = gsap.timeline({
                scrollTrigger: {
                  start: "0% 100%", 
                  end: "80% 65%", 
                  scrub: true,
                  trigger: container,
                  toggleActions: "play pause resume reset", // onEnter, onLeave, onEnterBack, and onLeaveBack
                  markers: false
                }
              });
              tl.fromTo(img, 2, {marginTop:"0"}, {marginTop:"-18%"},);    
            });  
         }
      
      
      
      
      

    },

      // mobile: 
    "(max-width: 1023px)": function() {
      // setup animations and ScrollTriggers for screens 1023px wide or less here...
      // The ScrollTriggers created inside these functions are segregated and get reverted/killed when the media query doesn't match anymore. 

        // =======================================================
        // ***** PDP: HAND ANIMATIONS - MOBILE ******
        // =======================================================
         if( $('.template-product').length ){   
          gsap.utils.toArray(".js_hand-animation-mob").forEach((container) => {
              let img = container.querySelector("img");
              let trigger = $('.js_single-product-photo');
              let tl = gsap.timeline({
                scrollTrigger: {
                  start: "0% 50%", 
                  end: "100% 0%", 
                  scrub: false, 
                  trigger: trigger,
                  toggleActions: "play reset play reset", // onEnter, onLeave, onEnterBack, and onLeaveBack
                  markers: false
                }
              });
              tl.fromTo(img, 1, {marginTop:"40%"}, {marginTop:"0"},);    
            });  
         }
    },

    // all 
    "all": function() {
      // ScrollTriggers created here aren't associated with a particular media query,
      // so they persist.

    }

  }); 

    



  }; // end GSAP on load wrapper

} ) ( jQuery );